export default {"src":"/_next/static/media/docker.0e32b87d.svg","height":2500,"width":2269,"blurWidth":0,"blurHeight":0};